import { Drawer } from "antd";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Content } from "./TasksPage.styled";
import {
  TasksList,
  TaskDetails,
  SingleOrderContextProvider,
  useMode,
} from "../../organisms";
import { useFilters } from "../../templates/filter-context/useFilters";
import { useQueryClient } from "react-query";
import { useIsMobile } from "../../../hooks/useIsMobile";
import {
  createQuery,
  queryStringToObject,
  removeUndefinedFields,
  removeUnusedFields,
} from "../../organisms/filters/Filter.utils";

const TasksPageContent: React.FC<{ defaultFilters: any }> = ({
  defaultFilters,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const { setMode } = useMode();

  const paramas = queryStringToObject(location.search);

  const closeDetails = () => {
    const nextParams = { ...paramas };
    delete nextParams.id;
    navigate({
      pathname: location.pathname,
      search: createQuery(nextParams),
    });
    setMode("read");
  };

  return (
    <Content>
      <TasksList defaultFilters={defaultFilters} />
      <Drawer
        placement="right"
        open={!!paramas.id}
        onClose={closeDetails}
        width={isMobile ? "100%" : 720}
        destroyOnClose
        styles={{ body: { padding: "8px 16px" } }}
      >
        <TaskDetails />
      </Drawer>
    </Content>
  );
};

export const TasksPage: React.FC = () => {
  const { setFilters } = useFilters();
  const queryClient = useQueryClient();
  const location = useLocation();

  const user: any = queryClient.getQueryData(["/current-user"]);

  // Default view: only my tasks, in every status except DONE and FAILED.
  const defaultFilters = {
    status: ["NEW", "ASSIGNED", "IN_PROGRESS", "ACCEPTED"],
    assignes: [`${user?.user_id ?? ""}`],
  };

  useEffect(() => {
    const urlFilters = removeUnusedFields(
      removeUndefinedFields(queryStringToObject(location.search))
    );
    if (Object.keys(urlFilters).length === 0) {
      setFilters(defaultFilters);
    }
  }, []);

  return (
    <SingleOrderContextProvider disableReadMode={false}>
      <TasksPageContent defaultFilters={defaultFilters} />
    </SingleOrderContextProvider>
  );
};
